if (!customElements.get('share-button')) {
  customElements.define(
    'share-button',
    class ShareButton extends HTMLElement {
      connectedCallback() {
        if (this.trigger) return;
        this.trigger = this.querySelector('.share-button__button');
        this.panel = this.querySelector('.share-button__fallback');
        this.closeButton = this.querySelector('.share-button__close');
        this.message = this.querySelector('.share-button__message');
        this.urlInput = this.querySelector('input');

        this.trigger.addEventListener('click', () => this.share());
        this.urlInput.addEventListener('focus', () => this.urlInput.select());
        this.querySelector('.share-button__copy').addEventListener('click', () => this.copy());
        this.closeButton.addEventListener('click', () => this.close(true));
        this.addEventListener('focusout', (event) => {
          if (!this.panel.hidden && !this.contains(event.relatedTarget)) this.close();
        });
        this.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape' || this.panel.hidden) return;
          event.stopPropagation();
          this.close(true);
        });
        if (!navigator.share) this.enableFallback();
        this.trigger.classList.remove('hidden');
      }

      enableFallback() {
        this.trigger.setAttribute('aria-controls', this.panel.id);
        this.trigger.setAttribute('aria-expanded', String(!this.panel.hidden));
      }

      async share() {
        if (navigator.share && !this.trigger.hasAttribute('aria-controls')) {
          try {
            await navigator.share({ url: this.urlInput.value, title: document.title });
            return;
          } catch (error) {
            if (error.name === 'AbortError') return;
            this.enableFallback();
          }
        }
        if (!this.panel.hidden) {
          this.close();
          return;
        }
        this.panel.hidden = false;
        this.trigger.setAttribute('aria-expanded', 'true');
      }

      close(restoreFocus = false) {
        if (restoreFocus) this.trigger.focus();
        this.panel.hidden = true;
        this.trigger.setAttribute('aria-expanded', 'false');
        this.message.classList.add('hidden');
        this.message.textContent = '';
        this.closeButton.classList.add('hidden');
      }

      async copy() {
        try {
          await navigator.clipboard.writeText(this.urlInput.value);
          if (this.panel.hidden) return;
          this.message.classList.remove('hidden');
          this.message.textContent = window.accessibilityStrings.shareSuccess;
          this.closeButton.classList.remove('hidden');
          this.closeButton.focus();
        } catch {
          if (!this.panel.hidden) this.urlInput.focus();
        }
      }

      updateUrl(url) {
        this.querySelector('input').value = url;
      }
    },
  );
}
